import classNames from 'classnames';
import { CSSProperties, memo } from 'react';
import styles from './index.less';

interface LoadingIconProps {
  description?: string;
  animation?: boolean;
  style?: CSSProperties | undefined;
  descStyle?: CSSProperties | undefined;
}

const LoadingIcon = memo((props: LoadingIconProps) => {
  const { animation = true, description = '数据加载中', descStyle } = props;
  return (
    <div className={classNames(styles['loading-icon'], styles['fade-in'])} style={props?.style}>
      <div className={styles['loading-wrapper']}>
        <div className={styles['loading-item']} style={{ '--delay': '0s' } as any} />
        <div className={styles['loading-item']} style={{ '--delay': '0.1s' } as any} />
        <div className={styles['loading-item']} style={{ '--delay': '0.2s' } as any} />
        <div className={styles['loading-item']} style={{ '--delay': '0.3s' } as any} />
        <div className={styles['loading-item']} style={{ '--delay': '0.4s' } as any} />
        <div className={styles['loading-item']} style={{ '--delay': '0.5s' } as any} />
      </div>
      <div className={classNames(styles['loading-description'])}>
        <div className={classNames(animation && styles['loading-animation'])} style={descStyle}>
          {description}
        </div>
      </div>
    </div>
  );
});

export default LoadingIcon;
